/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KmlInfo } from '../../models/kml-info';

export interface SynchronizeCoordinates$Params {
  raceClassGuid: string;
      body?: {
'file': Blob;
}
}

export function synchronizeCoordinates(http: HttpClient, rootUrl: string, params: SynchronizeCoordinates$Params, context?: HttpContext): Observable<StrictHttpResponse<KmlInfo>> {
  const rb = new RequestBuilder(rootUrl, synchronizeCoordinates.PATH, 'post');
  if (params) {
    rb.path('raceClassGuid', params.raceClassGuid, {"style":"simple"});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KmlInfo>;
    })
  );
}

synchronizeCoordinates.PATH = '/classes/{raceClassGuid}/synchCoordinates';
